// @ts-ignore
import day_logo_img from './img/day-logo.png'
// @ts-ignore
import tejaratno_logo_img from './img/tejaratno.png'
// @ts-ignore
import hamrah_logo_img from './img/logoText.png'
// @ts-ignore
import day_stamp_img from './img/stamp.png'
// @ts-ignore
import tejaratno_stamp_img from './img/tejaratno-stamp.png'
export {
    day_logo_img,
    hamrah_logo_img,
    day_stamp_img,
    tejaratno_logo_img,
    tejaratno_stamp_img,
}

export const FONTS = ['b-nazanin', 'iranBold']

export function s2hm(seconds: number): string {
    let h = ~~(seconds / 3600) + ''
    let rm = seconds % 3600
    let m = ~~(rm / 60) + ''
    let s = (rm % 60) + ''
    return `${h.padStart(2, '0')}:${m.padStart(2, '0')}:${s.padStart(2, '0')}`
}

export function rand(min: number, max: number): number {
    return Math.random() * (max - min + 1) + min
}
